import { Publication } from '../types/epub';
import { Stamp } from '../drawing/types';
import { defaultStamps } from '../drawing/constants';
import { getBasePath } from '../utils/browser';

export default function getStamps(publication: Publication | undefined): Stamp[] {
  const basePath = getBasePath();
  const viewerStamps = defaultStamps.map((stamp) => {
    return { ...stamp, path: `${basePath}/${stamp.path}` };
  });

  if (!publication || publication === null) {
    return viewerStamps;
  }

  const extraStamps = publication.extraStamps.map((stamp) => {
    return { ...stamp, path: `${publication.resourceDir}/${stamp.path}` };
  });

  return [...viewerStamps, ...extraStamps];
}
